import React from 'react';
import { Database, Activity } from 'lucide-react';
import type { DNSZone, DNSRecord } from '../../../types/dns';

interface ZoneOverviewProps {
  zone: DNSZone;
  recordCount: number;
}

const ZoneOverview: React.FC<ZoneOverviewProps> = ({ zone, recordCount }) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'status-healthy';
      case 'inactive':
        return 'status-warning';
      case 'error':
        return 'status-error';
      default:
        return 'status-warning';
    }
  };

  return (
    <div>
      <h3 className="text-heading-2 text-slate-900 dark:text-white mb-4">Overview</h3>
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Database className="w-4 h-4 text-slate-500" />
            <span className="text-body-small text-slate-500 dark:text-slate-400">
              Records
            </span>
          </div>
          <span className="text-heading-1 text-slate-900 dark:text-white">
            {recordCount}
          </span>
        </div>
        <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Activity className="w-4 h-4 text-slate-500" />
            <span className="text-body-small text-slate-500 dark:text-slate-400">
              Status
            </span>
          </div>
          <span className={`status ${getStatusColor(zone.status)}`}>
            {zone.status}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ZoneOverview;